import type { CreditsTier } from './types';
import { discountPct, formatShort, stepPct } from './utils';
import {
  Tick,
  TickBonus,
  TickLabel,
  TicksRow,
} from './styles/CreditsTicks.styles';

export type CreditsTicksProps = {
  tiers: CreditsTier[];
  activeIndex: number;
  onSelectIndex: (index: number) => void;
  compact?: boolean;
};

// A tier's "deal" is whichever it actually has — bonus credits and a price
// discount are independent fields (bonus_sku_size vs discount_pct_for_currency)
// and a tier can have either, both, or neither.
const tickDeal = (tier: CreditsTier) => {
  if (tier.bonusCredits > 0) {
    return {
      label: `+${Math.round((tier.bonusCredits / tier.credits) * 100)}%`,
      hasDeal: true,
    };
  }
  const pct = discountPct(tier.price, tier.strikePrice);
  if (pct > 0) {
    return { label: `-${pct}%`, hasDeal: true };
  }
  return { label: '—', hasDeal: false };
};

const CreditsTicks = ({
  tiers,
  activeIndex,
  onSelectIndex,
  compact,
}: CreditsTicksProps) => (
  <TicksRow>
    {tiers.map((tier, i) => {
      const active = i === activeIndex;
      const deal = tickDeal(tier);
      return (
        <Tick
          key={tier.id}
          onClick={() => onSelectIndex(i)}
          style={{ left: `${stepPct(i, tiers.length)}%` }}
        >
          <TickLabel active={active} compact={compact}>
            {formatShort(tier.credits)}
          </TickLabel>
          <TickBonus active={active} hasBonus={deal.hasDeal} compact={compact}>
            {deal.label}
          </TickBonus>
        </Tick>
      );
    })}
  </TicksRow>
);

export default CreditsTicks;
